import { EffectsIcon } from "@au-schein-de/au-ui-library";
import type { ProductNoEdibleInfo } from "@dransay/api";
import { getProductDetails } from "@dransay/api/models";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function ProductCardEffects({
	product,
}: {
	product: ProductNoEdibleInfo;
}) {
	const { t } = useTranslation("product");

	const effect = useMemo(
		() => getProductDetails(product).effects.best[0]?.item,
		[product],
	);

	if (!effect) return null;

	return (
		<div className="flex items-center max-w-6/12">
			<EffectsIcon name={effect} size="sm" />
			<div className="ml-1.5 capitalize text-body-sm text-gray-700 truncate overflow-hidden whitespace-nowrap">
				{/* @ts-ignore: dynamic key generation */}
				{t(`filters.effects.${effect}`)}
			</div>
		</div>
	);
}
